import getENV from '../env';

export const getV3Key = () => {
  return getENV().RECAPTCHA_V3_KEY
}

export const getV2Key = () => {
  return getENV().RECAPTCHA_V2_KEY
}
